// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"719":"e575c410","776":"d7a28d76","919":"847e8817"}[chunkId] + ".chunk.js";
};